import { h } from 'preact';
import SVGWrapper from '../../../../../../common/components/svg/SvgWrapper';

function FullscreenOnIcon({ height = 60, width = 60, color = 'white' }) {
  return (
    <SVGWrapper
      width={width}
      height={height}
      viewBox="8 1 32 32"
      fill="none"
    >
      <g fill={color}>
        <path d="M20.9001 13.0002L20.8983 13.7492C20.8972 14.1969 20.5289 14.5567 20.0814 14.5448C16.8262 14.4578 13.5981 14.2631 10.4001 13.9635V12.1549C13.2761 12.4278 16.1769 12.6136 19.1001 12.7127V8.2002H20.9001V13.0002Z" fill="white" />
        <path d="M20.9001 20.9963L20.8983 20.2473C20.8972 19.7996 20.5289 19.4397 20.0814 19.4517C16.8262 19.5386 13.5981 19.7334 10.4001 20.033V21.8416C13.2761 21.5687 16.1769 21.3829 19.1001 21.2838V25.7963H20.9001V20.9963Z" fill="white" />
        <path d="M27.1041 13.0002L27.106 13.7492C27.1071 14.1969 27.4754 14.5567 27.9229 14.5448C31.1781 14.4578 34.4062 14.2631 37.6041 13.9635V12.1549C34.7282 12.4278 31.8274 12.6136 28.9041 12.7127V8.2002H27.1041V13.0002Z" fill="white" />
        <path d="M27.1041 20.9963L27.106 20.2473C27.1071 19.7996 27.4754 19.4397 27.9229 19.4517C31.1781 19.5386 34.4062 19.7334 37.6041 20.033V21.8416C34.7282 21.5687 31.8274 21.3829 28.9041 21.2838V25.7963H27.1041V20.9963Z" fill="white" />
      </g>
    </SVGWrapper>
  );
}

export default FullscreenOnIcon;
